import React from "react";
// import { useTranslation } from 'react-i18next'
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  useToast,
  HStack,
  FormErrorMessage,
  Avatar,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
// import { useApp } from "../contexts/AppContext";
import { useMultiState } from "../lib/hooks";
import { useTranslation } from "react-i18next";
import axios from "axios";
import createStudentMutation from "../graphql/mutations/createStudentUser";
import setPasswordMutation from "../graphql/mutations/setPassword";
import { useMutation } from "@apollo/client";
import { FaPencilAlt } from "react-icons/fa";
import { useHistory } from "react-router";
import PolicyLayout from "../components/layouts/PolicyLayout";
const URL = process.env.REACT_APP_UPLOAD_IMAGE;
const SignUpPage = (props) => {
  // const { lang } = useApp()
  // const { t } = useTranslation()
  const history = useHistory();
  const toast = useToast();
  const [setStudentUser] = useMutation(createStudentMutation);
  const [setPassword] = useMutation(setPasswordMutation);

  const initialStudent = {
    username: "",
    firstname: "",
    lastname: "",
    mobile: "",
    email: "",
    avatar: "",
    password: "",
    confirm_pass: "",
    confirm_email: "",
    policy: false,
  };

  const [fileavatar, setFileAvatar] = useMultiState({ data: null, base64: "" });
  const [dataStudent, setDataStudent] = useMultiState(initialStudent);
  const { isOpen, onOpen, onClose } = useDisclosure();
const { t } = useTranslation();
  const selectAvatarFile = (e) =>
    new Promise((resolve, reject) => {
      e.preventDefault();
      const file = e.currentTarget.files[0];
      setFileAvatar({ data: file });
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
        setFileAvatar({ base64: reader.result });
      };
      reader.onerror = (error) => reject(error);
    });

  const handleAddStudent = async (e) => {
    e.preventDefault();

    const usernameRegex = /^[A-Za-z0-9_]+$/;
    const passwordStrongRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{6,}$/;
    const weakPasswords = ["1234", "123456", "password", "abcd", "qwerty"];

    if (!dataStudent?.username) {
      toast({
        position: "top",
        title: "Warning",
        description: t('signUpPage.username_required'),
        status: "warning",
        duration: 6000,
        isClosable: true,
      });
      return;
    }

    if (!usernameRegex.test(dataStudent.username)) {
      toast({
        position: "top",
        title: "Invalid Username",
        description: t('signUpPage.username_invalid'),
        status: "warning",
        duration: 6000,
        isClosable: true,
      });
      return;
    }

    if (!dataStudent.firstname || !dataStudent.lastname) {
      toast({
        position: "top",
        title: "Warning",
        description: t('signUpPage.name_required'),
        status: "warning",
        duration: 6000,
        isClosable: true,
      });
      return;
    }

    if (
      !passwordStrongRegex.test(dataStudent.password) ||
      weakPasswords.includes(dataStudent.password)
    ) {
      toast({
        position: "top",
        title: "Weak Password",
        description:
          t('signUpPage.password_weak'),
        status: "warning",
        duration: 6000,
        isClosable: true,
      });
      return;
    }

    try {
      const response = await axios.post(URL, { photo: fileavatar.base64 });
      const { data: studentUserdata } = await setStudentUser({
        variables: {
          firstname: dataStudent?.firstname,
          lastname: dataStudent?.lastname,
          mobile: dataStudent?.mobile,
          username: dataStudent?.username,
          email: dataStudent?.email,
          avatar: response ? response?.data?.url : "",
        },
      });
      const { data: passworddata } = await setPassword({
        variables: {
          _id: studentUserdata?.createStudentUser?.recordId,
          password: dataStudent?.password,
        },
      });

      if (studentUserdata && passworddata) {
        toast({
          position: "top",
          title: "Success",
          description: t('signUpPage.signup_success'),
          status: "success",
          duration: 6000,
          isClosable: true,
        });
        setFileAvatar({ data: null, base64: "" });
        setDataStudent(initialStudent);
        history.push("/login");
      }
    } catch (Error) {
      toast({
        position: "top",
        title: "ERROR",
        description: `${
          Error?.graphQLErrors?.[0]?.message || "เกิดข้อผิดพลาดในการสมัครสมาชิก"
        }`,
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    }
  };
  const [errors, setErrors] = useMultiState({
    username: "",
  });
  const ModalShowPolicy = () => (
    <Modal onClose={onClose} isOpen={isOpen} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t('signUpPage.privacy')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <PolicyLayout />
          {/* <div style="position: relative; padding-top: 56.25%;"> */}

          {/* </div> */}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>{t('signUpPage.close')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );

  return (
    <Flex align={"center"} justify={"center"}>
      <Stack spacing={8} mx={"auto"} maxW={"lg"} py={5} px={6}>
        <Stack align={"center"}>
          <Heading fontSize={"4xl"}>{t('signUpPage.create_account')}</Heading>
          <Text fontSize={"lg"} color={"gray.600"}>
            {t('signUpPage.subtitle')}
          </Text>
        </Stack>
        <form onSubmit={handleAddStudent} id="myform">
          <Box
            rounded={"lg"}
            bg={useColorModeValue("white", "gray.700")}
            boxShadow={"lg"}
            p={8}
          >
            <Stack align="center" py={"20px"}>
              {/* <AspectRatio maxW="560px" ratio={'9/16'}> */}
              {/* <Box
            w={'100px'}
            h={'300px'}
        > */}{" "}
              <HStack align="flex-start">
                <label
                  style={{ position: "relative" }}
                  htmlFor="photo-project-file"
                >
                  <Avatar
                    objectFit="cover"
                    // position='relative'
                    // boxShadow='md'
                    zIndex={1}
                    name={
                      dataStudent?.firstname
                        ? `${dataStudent?.firstname} ${dataStudent?.lastname}`
                        : "Profile"
                    }
                    size="lg"
                    src={fileavatar?.base64}
                    alt="กรุณาเลือกรูปภาพ"
                  />
                  {/* <Stack
                                        direction='column'
                                        maxW={'200px'}
                                    > */}
                  <IconButton
                    isRound
                    as="label"
                    bgColor="white"
                    htmlFor="photo-project-file"
                    // colorScheme='linkedin'
                    position="absolute"
                    top={10}
                    left={39}
                    // zIndex={-1}

                    size="xs"
                    fontSize={"15px"}
                    zIndex="sticky"
                    boxShadow="lg"
                    // variant="solid"
                    // isDisabled
                    icon={<FaPencilAlt style={{ zIndex: -1 }} />}
                    color="green.500"
                  />
                  <input
                    onChange={selectAvatarFile}
                    accept="image/*"
                    id="photo-project-file"
                    type="file"
                    style={{ display: "none" }}
                  />

                  {/* <Text isTruncated mt={5} align={'center'} fontSize={'lg'} color={'gray.500'}>
                                        {fileavatar?.data?.name}
                                    </Text> */}
                  {/* </Stack > */}
                </label>
              </HStack>
            </Stack>
            <Stack spacing={4}>
              <FormControl
                id="username"
                isRequired
                isInvalid={!!errors.username}
              >
                <FormLabel>{t("signUpPage.username")}</FormLabel>
                <Input
                  value={dataStudent?.username}
                  onChange={(e) => {
                    const value = e.target.value;
                    setDataStudent({ username: value });

                    // Only allow A-Z, a-z, 0-9, _
                    const usernameRegex = /^[A-Za-z0-9_]*$/;
                    if (!usernameRegex.test(value)) {
                      setErrors({
                        username:
                          t("signUpPage.username_invalid"),
                      });
                    } else {
                      setErrors({ username: "" });
                    }
                  }}
                  type="text"
                />
                <FormErrorMessage>{errors.username}</FormErrorMessage>
              </FormControl>
              <HStack>
                <FormControl id="firstname" isRequired>
                  <FormLabel>{t('signUpPage.firstname')}</FormLabel>
                  <Input
                    type="text"
                    value={dataStudent?.firstname}
                    onChange={(e) => {
                      setDataStudent({ firstname: e.target.value });
                    }}
                  />
                </FormControl>
                <FormControl id="lastname" isRequired>
                  <FormLabel>{t('signUpPage.lastname')}</FormLabel>
                  <Input
                    type="text"
                    value={dataStudent?.lastname}
                    onChange={(e) => {
                      setDataStudent({ lastname: e.target.value });
                    }}
                  />
                </FormControl>
              </HStack>
              <FormControl id="mobile">
                <FormLabel>{t('signUpPage.mobile')}</FormLabel>
                <Input
                  type="tel"
                  value={dataStudent?.mobile}
                  onChange={(e) => {
                    setDataStudent({ mobile: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl id="email">
                <FormLabel>{t('signUpPage.email')}</FormLabel>
                <Input
                  type="email"
                  value={dataStudent?.email}
                  onChange={(e) => {
                    setDataStudent({ email: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl
                id="email_confirm"
                isDisabled={!dataStudent?.email}
                isInvalid={
                  dataStudent?.confirm_email &&
                  !(dataStudent?.email === dataStudent?.confirm_email)
                }
              >
                <FormLabel>{t('signUpPage.confirm_email')}</FormLabel>
                <Input
                  type="email"
                  value={dataStudent?.confirm_email}
                  onChange={(e) => {
                    setDataStudent({ confirm_email: e.target.value });
                  }}
                />
                <FormErrorMessage>{t('signUpPage.wrong_email')}</FormErrorMessage>
              </FormControl>
              <FormControl id="password" isRequired isInvalid={!!errors.password}>
  <FormLabel>{t('signUpPage.password')}</FormLabel>
  <Input
    type="password"
    value={dataStudent?.password}
    onChange={(e) => {
      const newPassword = e.target.value;
      setDataStudent({ password: newPassword });

      // Password strength logic
      if (
        newPassword.length < 6 ||
        ["1234", "123456", "password", "qwerty"].includes(newPassword.toLowerCase())
      ) {
        setErrors({ password: t('signUpPage.password_weak') });
      } else {
        setErrors({ password: "" });
      }
    }}
  />
  <FormErrorMessage>{errors.password}</FormErrorMessage>
</FormControl>
              <FormControl
                isDisabled={!dataStudent?.password}
                isInvalid={
                  dataStudent?.confirm_pass &&
                  !(dataStudent?.password === dataStudent?.confirm_pass)
                }
                id="password-confirm"
                isRequired
              >
                <FormLabel>{t('signUpPage.confirm_password')}</FormLabel>
                <Input
                  value={dataStudent?.confirm_pass}
                  onChange={(e) => {
                    setDataStudent({ confirm_pass: e.target.value });
                  }}
                  errorBorderColor="red.300"
                  type="password"
                />
                <FormErrorMessage>รหัสผ่านไม่ตรงกัน</FormErrorMessage>
              </FormControl>
              <Stack
                mt={"20px"}
                direction={{ base: "row", sm: "row" }}
                align="flex-end"
                justify={"flex-end"}
              >
                <HStack>
                  {/* <label for> */}
                  <Checkbox
                    id="checkbox-policy"
                    value={dataStudent?.policy && dataStudent?.policy}
                    onChange={(e) => {
                      setDataStudent({ policy: e.target.checked });
                    }}
                  >
                    {t('signUpPage.accept')}
                  </Checkbox>
                  <Link onClick={onOpen} color="green" colorScheme="green">
                    {" "}
                    {t('signUpPage.privacy_policy')}
                  </Link>
                  <Text>{t('signUpPage.private')}</Text>
                  {/* </label> */}
                </HStack>
                {/* <Link as={RouteLink} to={'/signup'} mt={'-10px'} color={'blue.400'}>สร้างบัญชี</Link> */}
              </Stack>
              <Stack>
                <Button
                  disabled={!dataStudent?.policy}
                  bg={"blue.400"}
                  type="submit"
                  color={"white"}
                  _hover={{
                    bg: "blue.500",
                  }}
                >
                  {t('signUpPage.submit')}
                </Button>
              </Stack>
            </Stack>
          </Box>
        </form>
      </Stack>
      <ModalShowPolicy />
    </Flex>
  );
};

export default SignUpPage;
